import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Page, BlockStack, Text, Spinner, Box } from '@shopify/polaris';
import Logo from '../../../components/logo';

/**
 * HomePage - Landing page with automatic redirect
 *
 * Root authentication page that automatically redirects to login.
 * Shows loading state during redirect. Can be expanded in the future
 * with marketing content, features overview, or product information.
 *
 * @example
 * <Route path="/" element={<HomePage />} />
 */
export default function HomePage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to login after brief delay
    const timer = setTimeout(() => {
      navigate('/login', { replace: true });
    }, 100);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Page>
      <Box paddingBlockStart="2000">
        <BlockStack gap="400" align="center">
          <Logo size="medium" showText align="center" />
          <Spinner size="small" />
          <Text variant="bodyMd" tone="subdued" alignment="center">
            Redirecting...
          </Text>
        </BlockStack>
      </Box>
    </Page>
  );
}
